import { ReactNode } from "react";

import { StyledChangeTag, StyledMarkedBlock } from "./styled";

/** Names the toggle a block of a document mock owes its presence to. */
export function PreviewBlock({
  tag,
  icon = "pi pi-bolt",
  children,
}: {
  tag: string;
  icon?: string;
  children: ReactNode;
}) {
  return (
    <StyledMarkedBlock>
      <StyledChangeTag>
        <i className={icon} />
        {tag}
      </StyledChangeTag>
      {children}
    </StyledMarkedBlock>
  );
}
